<template>
  <div v-if="showTransDetail" class="trans-modal">
    <div class="modal-content-container">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ modalTransDetail.product.toUpperCase() }}</h3>
          <button class="close-btn" @click="closeModal">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-width="2"
                d="M6 18L18 6m0 12L6 6"
              />
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="modal-grid">
            <div class="grid-row">
              <div class="grid-col">
                <h3>Wallet Details</h3>
                <div class="item-row">
                  <p>Terminal ID:</p>
                  <p>{{ modalTransDetail.terminalId }}</p>
                </div>
                <div class="item-row">
                  <p>Agent ID:</p>
                  <p>{{ modalTransDetail.agentId }}</p>
                </div>
                <div class="item-row">
                  <p>Wallet ID:</p>
                  <p>{{ modalTransDetail.walletId }}</p>
                </div>
              </div>
              <div class="grid-col">
                <h3>Service Details</h3>
                <div class="item-row">
                  <p>Channel:</p>
                  <p>{{ modalTransDetail.channel }}</p>
                </div>
                <div class="item-row">
                  <p>Message:</p>
                  <p>{{}}</p>
                </div>
                <div class="item-row">
                  <p>Provider:</p>
                  <p>{{ modalTransDetail.provider }}</p>
                </div>
              </div>
            </div>
            <div class="grid-row">
              <div class="grid-col">
                <h3>Customer Details</h3>
                <div class="item-row">
                  <p>Phone number:</p>
                  <p>{{}}</p>
                </div>
                <div class="item-row">
                  <p>Customer Name:</p>
                  <p>{{ modalTransDetail.customerName }}</p>
                </div>
              </div>
              <div class="grid-col">
                <h3>Transaction References</h3>
                <div class="item-row">
                  <p>Sequence:</p>
                  <p>{{}}</p>
                </div>
                <div class="item-row">
                  <p>Ref:</p>
                  <p
                    class="text-truncate"
                    :title="modalTransDetail.reference"
                    style="max-width: 150px"
                  >
                    {{ modalTransDetail.reference }}
                  </p>
                </div>
              </div>
            </div>
            <div class="grid-row">
              <div class="grid-col">
                <h3>Transaction Details</h3>
                <div class="item-row">
                  <p>Amount:</p>
                  <p>{{ modalTransDetail.amount }}</p>
                </div>
                <div class="item-row">
                  <p>Account Number:</p>
                  <p>{{ modalTransDetail.account }}</p>
                </div>
                <div class="item-row">
                  <p>Account Name:</p>
                  <p>{{ modalTransDetail.accountName }}</p>
                </div>
                <div class="item-row">
                  <p>Bank:</p>
                  <p>{{ modalTransDetail.bankName }}</p>
                </div>
                <div class="item-row">
                  <p>Payment Method:</p>
                  <p>{{ modalTransDetail.paymentMethod }}</p>
                </div>
              </div>
              <div class="grid-col">
                <h3></h3>
                <div class="item-row">
                  <p>Response</p>
                  <textarea name="" id="" cols="30" rows="10">{{
                    modalTransDetail.response
                  }}</textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-primary"
            :disabled="loading"
            style="
              display: flex;
              align-items: center;
              gap: 4px;
              justify-content: center;
            "
            @click="requery"
          >
            <span v-if="loading" class="spin"></span>Requery
          </button>

          <button
            class="btn btn-primary"
            @click="updateModal(modalTransDetail)"
          >
            Show receipt
          </button>
        </div>
      </div>
    </div>
    <VasReceiptModal
      :show-receipt="showReceipt"
      :receipt-detail="receiptDetail"
      :close-receipt="closeReceipt"
    />
  </div>
</template>

<script>
import VasReceiptModal from "./VasReceiptModal.vue";
import axios from "../../store/axios";
import Swal from "sweetalert2";

export default {
  components: {
    VasReceiptModal,
  },
  props: {
    showTransDetail: {
      type: Boolean,
      required: true,
    },
    closeModal: {
      type: Function,
      required: true,
    },
    modalTransDetail: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showReceipt: false,
      receiptDetail: {},
      loading: false,
    };
  },
  methods: {
    updateModal(tran) {
      this.showReceipt = true;
      this.receiptDetail = tran;
    },
    closeReceipt() {
      this.showReceipt = false;
    },
    closeModal() {
      this.closeModal = false;
    },

    async requery() {
      if (!this.modalTransDetail || !this.modalTransDetail.reference) {
        throw new Error("No transaction reference found");
      }

      try {
        this.loading = true;
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/requery/${this.modalTransDetail.reference}`,
        );

        Swal.fire({
          title: `${res.data.status
            .charAt(0)
            .toUpperCase()}${res.data.status.slice(1)}`,
          text: `${res.data.message}`,
          icon: "success",
          confirmButtonText: "OK",
          showCancelButton: false,
        }).then(() => {
          this.closeModal();
        });
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Sales Officers",
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.trans-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  width: 100%;
  height: 100%;
}

.modal-content-container {
  background-color: white;
  max-width: 80%;
  width: 800px;
  border-radius: 15px;
  overflow-y: auto;
}

.modal-content {
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  background-color: transparent;
  padding: 8px 20px;
  width: 10px;
  border: none;
  border-radius: 5px;
}

.close-btn svg {
  width: 20px;
  object-fit: contain;
}

.modal-body {
  padding: 30px;
}

.grid-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
}

.grid-col {
  flex: 1;
}

.item-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.item-row p {
  margin: 5px 0;
}

.modal-footer {
  display: flex;
  justify-content: center;
  padding: 10px 0;
}

.swal2-title {
  text-transform: capitalize !important;
}
</style>
